import React from 'react';
import Formulario from "./components/Formulario";
import Lista from "./components/Lista";

const Proveedores = props => {
    const path = props.match.path;
    return (
        <React.Fragment>
            {(path === '/proveedor/new' || path.indexOf('/proveedor/edit') === 0) && <Formulario {...props}/>}
            {path === '/proveedor/list' && <Lista {...props}/>}
        </React.Fragment>
    );
};

export default Proveedores;
